/**
 * Cliente Delete Dialog Component
 */

import { GenericDeleteDialog } from "@/components/ui/generic-delete-dialog";
import { Cliente } from "@/types/cliente";

interface ClienteDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cliente: Cliente | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function ClienteDeleteDialog({
  open,
  onOpenChange,
  cliente,
  onConfirm,
  isLoading = false,
}: ClienteDeleteDialogProps) {
  return (
    <GenericDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      item={cliente}
      onConfirm={onConfirm}
      isLoading={isLoading}
      entityName="Cliente"
      getItemLabel={(c) => c.nome}
    />
  );
}
